import { all, fork, spawn } from 'redux-saga/effects';

import { authenticationSaga } from '../../features/authenticationSlice';
import { bootstrapSaga } from '../../features/bootstrapSlice';
import { globalMessageSaga } from '../../features/globalMessageSlice';

import { cityAreaSaga } from '../../features/apiFeatures/cityAreaSlice';
import { commentSaga } from '../../features/apiFeatures/commentSlice';
import { fieldTemplateSaga } from '../../features/apiFeatures/fieldTemplateSlice';
import { globalContentSaga } from '../../features/apiFeatures/globalContentSlice';
import { globalContentTypesSaga } from '../../features/apiFeatures/globalContentTypeSlice';
import { hearingRoleSaga } from '../../features/apiFeatures/hearingRoleSlice';
import { hearingSaga } from '../../features/apiFeatures/hearingSlice';
import { hearingStatusSaga } from '../../features/apiFeatures/hearingStatusSlice';
import { hearingTemplateSaga } from '../../features/apiFeatures/hearingTemplateSlice';
import { hearingTypeSaga } from '../../features/apiFeatures/hearingTypeSlice';
import { invitationGroupMappingSaga } from '../../features/apiFeatures/invitationGroupMappingSlice';
import { invitationGroupSaga } from '../../features/apiFeatures/invitationGroupSlice';
import { invitationKeySaga } from '../../features/apiFeatures/invitationKeySlice';
import { invitationSourceSaga } from '../../features/apiFeatures/invitationSourceSlice';
import { kleHierarchySaga } from '../../features/apiFeatures/kleHierarchySlice';
import { kleMappingSaga } from '../../features/apiFeatures/kleMappingSlice';
import { notificationContentSaga } from '../../features/apiFeatures/notificationContentSlice';
import { notificationContentSpecificationSaga } from '../../features/apiFeatures/notificationContentSpecificationSlice';
import { notificationSaga } from '../../features/apiFeatures/notificationSlice';
import { subjectAreaSaga } from '../../features/apiFeatures/subjectAreaSlice';
import { userHearingRoleSaga } from '../../features/apiFeatures/userHearingRoleSlice';
import { userSaga } from '../../features/apiFeatures/userSlice';
import { versionSaga } from '../../features/apiFeatures/versionSlice';

import { administrationPageSaga } from '../../features/pageFeatures/administrationPageSlice';
import { cityAreaAdministrationPageSaga } from '../../features/pageFeatures/cityAreaAdministrationPageSlice';
import { createHearingPageSaga } from '../../features/pageFeatures/createHearingPageSlice';
import { fieldTemplateAdministrationPageSaga } from '../../features/pageFeatures/fieldTemplateAdministrationPageSlice';
import { globalContentAdministrationPageSaga } from '../../features/pageFeatures/globalContentAdministrationPageSlice';
import { hearingTypeAdministrationSaga } from '../../features/pageFeatures/hearingTypeAdministrationPageSlice';
import { invitationGroupAdministrationPageSaga } from '../../features/pageFeatures/invitationGroupAdministrationPageSlice';
import { kleMappingAdministrationPageSaga } from '../../features/pageFeatures/kleMappingAdministrationPageSlice';
import { myHearingsPageSaga } from '../../features/pageFeatures/myHearingsPageSlice';
import { subjectAreaAdministrationPageSaga } from '../../features/pageFeatures/subjectAreaAdministrationPageSlice';

import { commentSectionSaga } from '../../features/componentFeatures/commentSectionSlice';
import { hearingOverviewSaga } from '../../features/componentFeatures/hearingOverviewSlice';
import { notificationPanelSaga } from '../../features/componentFeatures/notificationPanelSlice';
import { renderHearingSaga } from '../../features/componentFeatures/renderHearingSlice';

function* apiSaga() {
  yield all([
    fork(hearingSaga),
    fork(versionSaga),
    fork(cityAreaSaga),
    fork(subjectAreaSaga),
    fork(hearingTypeSaga),
    fork(hearingStatusSaga),
    fork(userSaga),
    fork(userHearingRoleSaga),
    fork(commentSaga),
    fork(globalContentTypesSaga),
    fork(globalContentSaga),
    fork(hearingTemplateSaga),
    fork(kleMappingSaga),
    fork(fieldTemplateSaga),
    fork(hearingRoleSaga),
    fork(invitationGroupSaga),
    fork(invitationGroupMappingSaga),
    fork(invitationKeySaga),
    fork(invitationSourceSaga),
    fork(notificationSaga),
    fork(notificationContentSaga),
    fork(notificationContentSpecificationSaga),
  ]);
}

function* componentSaga() {
  yield all([
    fork(renderHearingSaga),
    fork(commentSectionSaga),
    fork(hearingOverviewSaga),
    fork(notificationPanelSaga),
  ]);
}

function* appSaga() {
  yield all([fork(globalMessageSaga)]);
}

function* pageSaga() {
  yield all([
    fork(createHearingPageSaga),
    fork(myHearingsPageSaga),
    fork(administrationPageSaga),
    fork(cityAreaAdministrationPageSaga),
    fork(subjectAreaAdministrationPageSaga),
    fork(globalContentAdministrationPageSaga),
    fork(hearingTypeAdministrationSaga),
    fork(kleHierarchySaga),
    fork(kleMappingAdministrationPageSaga),
    fork(fieldTemplateAdministrationPageSaga),
    fork(invitationGroupAdministrationPageSaga),
  ]);
}

export default function* rootSaga() {
  yield all([
    fork(bootstrapSaga),
    fork(authenticationSaga),
    fork(apiSaga),
    spawn(pageSaga),
    spawn(componentSaga),
    fork(appSaga),
  ]);
}
